import style from './Avatar.styl';

export function Avatar({ src }) {
  return (
    <img src={src} alt="" className={style.avatar} />
  );
}
